/* eslint-disable prettier/prettier */
import { apiService } from './api.service';

export interface FAQArticle {
	id: string;
	title: string;
	content: string;
	category?: string;
	tags?: string[];
	orderindex?: number;
	viewcount: number;
	helpfulcount: number;
	nothelpfulcount: number;
	ispublished: boolean;
	createdat: string;
	updatedat: string;
}

export interface FAQFilters {
	category?: string;
	search?: string;
	ispublished?: boolean;
}

export interface CreateFAQRequest {
	title: string;
	content: string;
	category?: string;
	tags?: string[];
	orderindex?: number;
}

class FAQService {
	// Toggle this to true to use API, false to use Mock
	private useMock = false;

	async getFAQArticles(filters?: FAQFilters) {
		try {
			const response = await apiService.get<FAQArticle[]>('faq', filters);
			if (!response.success)
				throw new Error(
					response.message || 'Failed to fetch FAQ articles'
				);
			return response.data;
		} catch (error) {
			console.error('Error in getFAQArticles:', error);
			throw error;
		}
	}

	async getFAQById(articleId: string) {
		try {
			const response = await apiService.get<FAQArticle>(
				`faq/${articleId}`
			);
			if (!response.success)
				throw new Error(
					response.message || 'Failed to fetch FAQ details'
				);
			return response.data;
		} catch (error) {
			console.error('Error in getFAQById:', error);
			throw error;
		}
	}

	async markHelpful(articleId: string, helpful: boolean) {
		try {
			const response = await apiService.post<void>(
				`faq/${articleId}/helpful`,
				{ helpful }
			);
			if (!response.success)
				throw new Error(
					response.message || 'Failed to record feedback'
				);
			return response.data;
		} catch (error) {
			console.error('Error in markHelpful:', error);
			throw error;
		}
	}

	/**
	 * Admin Methods
	 */
	async createFAQArticle(data: CreateFAQRequest) {
		try {
			const response = await apiService.post<string>('faq', data);
			if (!response.success)
				throw new Error(response.message || 'Failed to create FAQ');
			return response.data;
		} catch (error) {
			console.error('Error in createFAQArticle:', error);
			throw error;
		}
	}

	async updateFAQArticle(articleId: string, data: Partial<CreateFAQRequest>) {
		try {
			const response = await apiService.put<void>(
				`faq/${articleId}`,
				data
			);
			if (!response.success)
				throw new Error(response.message || 'Failed to update FAQ');
			return response.data;
		} catch (error) {
			console.error('Error in updateFAQArticle:', error);
			throw error;
		}
	}

	async deleteFAQArticle(articleId: string) {
		try {
			const response = await apiService.delete<void>(`faq/${articleId}`);
			if (!response.success)
				throw new Error(response.message || 'Failed to delete FAQ');
			return response.data;
		} catch (error) {
			console.error('Error in deleteFAQArticle:', error);
			throw error;
		}
	}

	async publishFAQArticle(articleId: string) {
		try {
			const response = await apiService.post<void>(
				`faq/${articleId}/publish`,
				{}
			);
			if (!response.success)
				throw new Error(response.message || 'Failed to publish FAQ');
			return response.data;
		} catch (error) {
			console.error('Error in publishFAQArticle:', error);
			throw error;
		}
	}
}

export const faqService = new FAQService();
